// 'CoreService' is a 'collector' of : services, tools, etc. for using inside this library
// in order to provide a kind of 'skeleton' that any application has to implement in order
// to use this library.
//
// Basically, an application that need to use this library has :
//
// - implement all interfaces provided by this library
// - Assign those related service to CoreService

import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {IAuthorizeService} from "libComm/interfaces/IAuthorizeService";
import {IAppInfoService} from "libComm/interfaces/IAppInfoService";
import {ITranslatorManager} from "libComm/interfaces/ITranslatorManager";
import {IIdentityService} from "libComm/interfaces/IIdentityService";
import {IMenuService} from "libComm/interfaces/IMenuService";

import {NavService} from "libComm/services/nav.service";


@Injectable({
	providedIn: 'root'
})
export class CoreService
{
	public as: any; // authService pointer
	public appInfo: any; // application info service provider
	private is: any; // identification service
	private trm: any; // translator manager
	private menus: any; // sidebar menu service
	private ns: any; // naviagation service

	constructor(public ts: TranslateService,
				public navs: NavService)
	{
		// this.initTranslatorDefault();
		this.as= null;
		this.appInfo= null;
		this.is= null;
		this.menus= null;
		this.ns= navs;
	}

	///////////////////////////////////////////////////////////
	// translation stuff

	// default initialization for translator
	initTranslatorDefault(): void
	{
		this.ts.setDefaultLang('gb'); // Set default language
		this.ts.addLangs(['gb', 'us', 'it']);  // set available translation languages
	}
	
	// return TranslatorService instance
	getTranslatorService(): TranslateService
	{
		return this.ts;
	}

	setTranslatorManager(trm: ITranslatorManager): void
	{
		this.trm= trm;
	}

	getTranslatorManager(): ITranslatorManager
	{
		return this.trm;
	}

	// apply a custom translation initializer, provided by the application
	applyCustomTranslatorInit(): void
	{
		this.trm.initTranslator(this.ts);
	}

	// switch language according to langId
	switchLang(langId: string): void
	{
		// this.ts.use(langId);

		// put last used language in app local storage
		// localStorage.setItem('lang', langId);
		this.trm.switchLangHandler(this.ts, langId);
	}

	///////////////////////////////////////////////////////////
	// Authorization services stuff
	setAuthService(auths:IAuthorizeService): void
	{
		this.as= auths;
	}

	getAuthService(): IAuthorizeService
	{
		return this.as;
	}

	///////////////////////////////////////////////////////////
	// Application info stuff
	setAppInfo(appInfo: IAppInfoService): void
	{
		this.appInfo= appInfo;
	}

	getAppInfo(): IAppInfoService
	{
		return this.appInfo;
	}

	///////////////////////////////////////////////////////////
	// Identity stuff
	getIdentityService(): IIdentityService
	{
		return this.is;
	}

	setIdentityService(identity: IIdentityService)
	{
		this.is = identity;
	}

	//////////////////////////////////////////////////////////
	// side-bar Menu Service stuff
	getMenuService(): IMenuService
	{
		return this.menus;
	}

	setMenuService(mns: IMenuService) : void
	{
		this.menus= mns;
	}

	//////////////////////////////////////////////////////////
	// navigation service stuff
	getNavService(): NavService
	{
		return this.ns;
	}
}
